<template>
  <div class="scr">
    <!-- ===== BERANDA ===== -->
    <template v-if="screen === 'home'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">{{ t.home.greeting }}</div>
          <div class="scr__household">{{ t.common.household }} <i class="fa fa-angle-down"></i></div>
        </div>
        <div class="scr__header-actions">
          <span class="scr__icon-btn"><i class="fa fa-bell"></i><span class="scr__badge-dot"></span></span>
          <span class="scr__avatar scr__avatar--rina">R</span>
        </div>
      </div>
      <div class="scr__body">
        <div class="scr__hero-card">
          <div class="scr__hero-label">{{ t.home.spendLabel }}</div>
          <div class="scr__hero-amount">{{ t.home.spendAmount }}</div>
          <div class="scr__progress scr__progress--light"><span style="width: 71%"></span></div>
          <div class="scr__hero-meta">
            <span>{{ t.home.budgetOf }}</span>
            <span>{{ t.home.daysLeft }}</span>
          </div>
        </div>

        <div class="scr__quick">
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-minus-circle"></i></span>{{ t.home.quick.log }}</div>
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-bolt"></i></span>{{ t.home.quick.bills }}</div>
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-shopping-basket"></i></span>{{ t.home.quick.shopping }}</div>
          <div class="scr__quick-item"><span class="scr__quick-icon"><i class="fa fa-wrench"></i></span>{{ t.home.quick.upkeep }}</div>
        </div>

        <div class="scr__section-title">{{ t.home.today }} <span>{{ t.home.todayDate }}</span></div>
        <div class="scr__card scr__list">
          <div class="scr__row">
            <span class="scr__time">07:00</span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.home.schoolRun }}</div>
              <div class="scr__row-sub">{{ t.home.dad }}</div>
            </div>
            <span class="scr__avatar scr__avatar--sm scr__avatar--budi">B</span>
          </div>
          <div class="scr__row">
            <span class="scr__check scr__check--done"><i class="fa fa-check"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title scr__row-title--done">{{ t.home.trash }}</div>
              <div class="scr__row-sub">{{ t.home.trashSub }}</div>
            </div>
            <span class="scr__avatar scr__avatar--sm scr__avatar--inah">I</span>
          </div>
          <div class="scr__row">
            <span class="scr__time">16:00</span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.home.piano }}</div>
              <div class="scr__row-sub">{{ t.home.pianoSub }}</div>
            </div>
            <span class="scr__avatar scr__avatar--sm scr__avatar--kirana">K</span>
          </div>
        </div>

        <div class="scr__section-title">{{ t.home.attention }}</div>
        <div class="scr__card scr__alert">
          <span class="scr__tile scr__tile--amber"><i class="fa fa-bolt"></i></span>
          <div class="scr__row-main">
            <div class="scr__row-title">{{ t.common.plnHome }}</div>
            <div class="scr__row-sub">{{ t.home.plnSub }}</div>
          </div>
          <span class="scr__pill-btn">{{ t.home.pay }}</span>
        </div>
        <div class="scr__card scr__alert">
          <span class="scr__tile scr__tile--blue"><i class="fa fa-snowflake-o"></i></span>
          <div class="scr__row-main">
            <div class="scr__row-title">{{ t.common.acService }}</div>
            <div class="scr__row-sub">{{ t.home.acSub }}</div>
          </div>
          <i class="fa fa-angle-right scr__chevron"></i>
        </div>
      </div>
    </template>

    <!-- ===== KAS & ANGGARAN ===== -->
    <template v-else-if="screen === 'budget'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">{{ t.budget.title }}</div>
          <div class="scr__household">{{ t.common.month }} <i class="fa fa-angle-down"></i></div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-plus"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__segmented">
          <span class="scr__segmented-item scr__segmented-item--active">{{ t.budget.shared }}</span>
          <span class="scr__segmented-item"><i class="fa fa-lock"></i> {{ t.budget.private }}</span>
        </div>

        <div class="scr__split">
          <div class="scr__card scr__stat">
            <div class="scr__stat-label"><i class="fa fa-arrow-down scr__text-green"></i> {{ t.budget.income }}</div>
            <div class="scr__stat-value">{{ t.budget.incomeAmount }}</div>
          </div>
          <div class="scr__card scr__stat">
            <div class="scr__stat-label"><i class="fa fa-arrow-up scr__text-red"></i> {{ t.budget.spending }}</div>
            <div class="scr__stat-value">{{ t.budget.spendingAmount }}</div>
          </div>
        </div>

        <div class="scr__section-title">{{ t.budget.categories }}</div>
        <div class="scr__card scr__budgets">
          <div v-for="b in budgets" :key="b.name" class="scr__budget">
            <div class="scr__budget-head">
              <span>{{ b.name }}</span>
              <span :class="{ 'scr__text-red': b.pct >= 100, 'scr__text-amber': b.pct >= 80 && b.pct < 100 }">
                {{ b.pct }}%
              </span>
            </div>
            <div class="scr__progress">
              <span :style="{ width: Math.min(b.pct, 100) + '%' }"
                :class="{ 'is-warn': b.pct >= 80 && b.pct < 100, 'is-over': b.pct >= 100 }"></span>
            </div>
            <div class="scr__budget-meta">{{ b.spent }} {{ t.budget.of }} {{ b.limit }}</div>
          </div>
        </div>

        <div class="scr__section-title">{{ t.budget.recent }}</div>
        <div class="scr__card scr__list">
          <div class="scr__row">
            <span class="scr__tile scr__tile--green"><i class="fa fa-shopping-basket"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.budget.weekly }}</div>
              <div class="scr__row-sub">{{ t.budget.weeklySub }}</div>
            </div>
            <span class="scr__amount">{{ t.budget.weeklyAmount }}</span>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--blue"><i class="fa fa-snowflake-o"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.budget.ac }} <span class="scr__chip">{{ t.budget.auto }}</span></div>
              <div class="scr__row-sub">{{ t.budget.acSub }}</div>
            </div>
            <span class="scr__amount">{{ t.budget.acAmount }}</span>
          </div>
        </div>
      </div>
    </template>

    <!-- ===== BAYAR TAGIHAN ===== -->
    <template v-else-if="screen === 'bills'">
      <div class="scr__header">
        <div class="scr__header-back">
          <i class="fa fa-chevron-left"></i>
          <div>
            <div class="scr__eyebrow">{{ t.bills.eyebrow }}</div>
            <div class="scr__household">{{ t.bills.title }}</div>
          </div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-history"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__bill-card">
          <div class="scr__bill-top">
            <span class="scr__bill-logo"><i class="fa fa-bolt"></i></span>
            <div>
              <div class="scr__bill-label">{{ t.bills.label }}</div>
              <div class="scr__bill-id">ID 5321 •••• 8812</div>
            </div>
          </div>
          <div class="scr__bill-grid">
            <div><span>{{ t.bills.name }}</span>R. SANTOSO</div>
            <div><span>{{ t.bills.period }}</span>{{ t.bills.periodValue }}</div>
            <div><span>{{ t.bills.usage }}</span>312 kWh</div>
            <div><span>{{ t.bills.due }}</span>{{ t.bills.dueValue }}</div>
          </div>
        </div>

        <div class="scr__card scr__breakdown">
          <div><span>{{ t.bills.bill }}</span><span>{{ t.bills.billAmount }}</span></div>
          <div><span>{{ t.bills.adminFee }}</span><span>{{ t.bills.adminAmount }}</span></div>
          <div class="scr__breakdown-total"><span>{{ t.bills.total }}</span><span>{{ t.common.total }}</span></div>
        </div>

        <div class="scr__section-title">{{ t.bills.payWith }}</div>
        <div class="scr__methods">
          <span class="scr__method scr__method--active"><i class="fa fa-qrcode"></i> QRIS</span>
          <span class="scr__method"><i class="fa fa-university"></i> VA</span>
          <span class="scr__method"><i class="fa fa-mobile"></i> E-wallet</span>
        </div>

        <div class="scr__section-title">{{ t.bills.usageChart }}</div>
        <div class="scr__card scr__bars">
          <div v-for="(m, i) in usage" :key="m.label" class="scr__bar">
            <span :style="{ height: m.value + '%' }" :class="{ 'is-current': i === usage.length - 1 }"></span>
            <small>{{ m.label }}</small>
          </div>
        </div>
      </div>
      <div class="scr__cta-bar">
        <span class="scr__cta">{{ t.bills.payCta }}</span>
      </div>
    </template>

    <!-- ===== AGENDA ===== -->
    <template v-else-if="screen === 'agenda'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">{{ t.agenda.title }}</div>
          <div class="scr__household">{{ t.common.month }} <i class="fa fa-angle-down"></i></div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-calendar"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__week">
          <div v-for="d in week" :key="d.date" class="scr__day" :class="{ 'scr__day--active': d.active }">
            <small>{{ d.name }}</small>
            <strong>{{ d.date }}</strong>
            <span v-if="d.dot" class="scr__day-dot"></span>
          </div>
        </div>

        <div class="scr__timeline">
          <div class="scr__event scr__event--purple">
            <div class="scr__event-time">07:00</div>
            <div class="scr__event-body">
              <div class="scr__row-title">{{ t.agenda.schoolRun }}</div>
              <div class="scr__row-sub">{{ t.agenda.schoolRunSub }}</div>
            </div>
          </div>
          <div class="scr__event scr__event--green">
            <div class="scr__event-time">10:00</div>
            <div class="scr__event-body">
              <div class="scr__row-title">{{ t.agenda.trash }}</div>
              <div class="scr__row-sub">{{ t.agenda.trashSub }}</div>
            </div>
          </div>
          <div class="scr__event scr__event--pink">
            <div class="scr__event-time">16:00</div>
            <div class="scr__event-body">
              <div class="scr__row-title">{{ t.agenda.piano }}</div>
              <div class="scr__avatars">
                <span class="scr__avatar scr__avatar--xs scr__avatar--kirana">K</span>
                <span class="scr__avatar scr__avatar--xs scr__avatar--rina">R</span>
                <span class="scr__rsvp-note">{{ t.agenda.pianoGoing }}</span>
              </div>
            </div>
          </div>
          <div class="scr__event scr__event--amber">
            <div class="scr__event-time">19:30</div>
            <div class="scr__event-body">
              <div class="scr__row-title">{{ t.common.familyArisan }}</div>
              <div class="scr__row-sub"><i class="fa fa-map-marker"></i> {{ t.agenda.grandma }}</div>
              <div class="scr__rsvp">
                <span class="scr__rsvp-btn scr__rsvp-btn--yes">{{ t.common.going }}</span>
                <span class="scr__rsvp-btn">{{ t.common.maybe }}</span>
                <span class="scr__rsvp-btn">{{ t.common.notGoing }}</span>
              </div>
            </div>
          </div>
          <div class="scr__event scr__event--muted">
            <div class="scr__event-time">{{ t.agenda.dueDate }}</div>
            <div class="scr__event-body">
              <div class="scr__row-title"><i class="fa fa-bolt"></i> {{ t.agenda.plnDue }}</div>
              <div class="scr__row-sub">{{ t.agenda.fromBills }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ===== DAFTAR BELANJA ===== -->
    <template v-else-if="screen === 'shopping'">
      <div class="scr__header">
        <div class="scr__header-back">
          <i class="fa fa-chevron-left"></i>
          <div>
            <div class="scr__eyebrow">{{ t.shopping.eyebrow }}</div>
            <div class="scr__household">{{ t.shopping.title }}</div>
          </div>
        </div>
        <div class="scr__avatars scr__avatars--stack">
          <span class="scr__avatar scr__avatar--xs scr__avatar--rina">R</span>
          <span class="scr__avatar scr__avatar--xs scr__avatar--inah">I</span>
          <span class="scr__avatar scr__avatar--xs scr__avatar--budi">B</span>
        </div>
      </div>
      <div class="scr__body">
        <div class="scr__live">
          <span class="scr__live-dot"></span>
          {{ t.shopping.live.pre }}<strong>{{ t.shopping.live.strong }}</strong>{{ t.shopping.live.post }}
        </div>
        <div class="scr__card scr__list">
          <div v-for="(item, index) in groceries" :key="index" class="scr__row">
            <span class="scr__check" :class="{ 'scr__check--done': item.done }">
              <i v-if="item.done" class="fa fa-check"></i>
            </span>
            <div class="scr__row-main">
              <div class="scr__row-title" :class="{ 'scr__row-title--done': item.done }">{{ item.name }}</div>
              <div class="scr__row-sub">{{ item.qty }}</div>
            </div>
            <span v-if="item.by" class="scr__avatar scr__avatar--xs" :class="'scr__avatar--' + item.by">
              {{ item.by.charAt(0).toUpperCase() }}
            </span>
          </div>
        </div>
        <div class="scr__estimate">
          <span>{{ t.shopping.estimate }}</span>
          <strong>{{ t.shopping.estimateAmount }}</strong>
        </div>
      </div>
      <div class="scr__cta-bar">
        <span class="scr__cta"><i class="fa fa-check-circle"></i> {{ t.shopping.done }}</span>
      </div>
    </template>

    <!-- ===== PERAWATAN ===== -->
    <template v-else-if="screen === 'maintenance'">
      <div class="scr__header">
        <div>
          <div class="scr__eyebrow">{{ t.maintenance.title }}</div>
          <div class="scr__household">{{ t.maintenance.subtitle }}</div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-plus"></i></span>
      </div>
      <div class="scr__body">
        <div class="scr__health">
          <div class="scr__health-item scr__health-item--red"><strong>1</strong><span>{{ t.maintenance.overdue }}</span></div>
          <div class="scr__health-item scr__health-item--amber"><strong>3</strong><span>{{ t.maintenance.thisMonth }}</span></div>
          <div class="scr__health-item"><strong>12</strong><span>{{ t.maintenance.scheduled }}</span></div>
        </div>
        <div class="scr__card scr__list">
          <div class="scr__row">
            <span class="scr__tile scr__tile--red"><i class="fa fa-car"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.maintenance.carTax }}</div>
              <div class="scr__row-sub scr__text-red">{{ t.maintenance.carTaxSub }}</div>
            </div>
            <i class="fa fa-angle-right scr__chevron"></i>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--blue"><i class="fa fa-snowflake-o"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.common.acService }}</div>
              <div class="scr__row-sub">{{ t.maintenance.acSub }}</div>
            </div>
            <span class="scr__avatar scr__avatar--xs scr__avatar--vendor">J</span>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--teal"><i class="fa fa-tint"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.maintenance.tank }}</div>
              <div class="scr__row-sub">{{ t.maintenance.tankSub }}</div>
            </div>
            <i class="fa fa-angle-right scr__chevron"></i>
          </div>
          <div class="scr__row">
            <span class="scr__tile scr__tile--green"><i class="fa fa-home"></i></span>
            <div class="scr__row-main">
              <div class="scr__row-title">{{ t.maintenance.propertyTax }}</div>
              <div class="scr__row-sub scr__text-green">{{ t.maintenance.propertyTaxSub }}</div>
            </div>
            <i class="fa fa-check-circle scr__text-green"></i>
          </div>
        </div>

        <div class="scr__section-title">{{ t.maintenance.handymen }}</div>
        <div class="scr__card scr__vendor">
          <span class="scr__avatar scr__avatar--vendor">J</span>
          <div class="scr__row-main">
            <div class="scr__row-title">{{ t.maintenance.vendor }}</div>
            <div class="scr__row-sub"><i class="fa fa-star scr__text-amber"></i> {{ t.maintenance.vendorSub }}</div>
          </div>
          <span class="scr__wa"><i class="fa fa-whatsapp"></i></span>
        </div>
      </div>
    </template>

    <!-- ===== CHAT ===== -->
    <template v-else-if="screen === 'chat'">
      <div class="scr__header">
        <div class="scr__header-back">
          <i class="fa fa-chevron-left"></i>
          <div>
            <div class="scr__household">{{ t.common.household }}</div>
            <div class="scr__eyebrow">{{ t.chat.members }}</div>
          </div>
        </div>
        <span class="scr__icon-btn"><i class="fa fa-ellipsis-h"></i></span>
      </div>
      <div class="scr__body scr__chat">
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--budi">B</span>
          <div class="scr__bubble">{{ t.chat.billOut }}</div>
        </div>
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--budi">B</span>
          <div class="scr__chat-card">
            <div class="scr__chat-card-head"><i class="fa fa-bolt"></i> {{ t.chat.billHead }}</div>
            <div class="scr__row-title">{{ t.common.plnHome }}</div>
            <div class="scr__chat-card-amount">{{ t.common.total }}</div>
            <div class="scr__row-sub">{{ t.chat.due }}</div>
            <div class="scr__chat-card-status"><i class="fa fa-check-circle"></i> {{ t.chat.paidBy }}</div>
          </div>
        </div>
        <div class="scr__msg scr__msg--me">
          <div class="scr__bubble scr__bubble--me">{{ t.chat.paidReply }}</div>
        </div>
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--eyang">E</span>
          <div class="scr__chat-card">
            <div class="scr__chat-card-head"><i class="fa fa-calendar"></i> {{ t.chat.eventHead }}</div>
            <div class="scr__row-title">{{ t.common.familyArisan }}</div>
            <div class="scr__row-sub">{{ t.chat.eventWhen }}</div>
            <div class="scr__rsvp">
              <span class="scr__rsvp-btn scr__rsvp-btn--yes">{{ t.common.going }}</span>
              <span class="scr__rsvp-btn">{{ t.common.maybe }}</span>
            </div>
          </div>
        </div>
        <div class="scr__msg">
          <span class="scr__avatar scr__avatar--xs scr__avatar--kirana">K</span>
          <div class="scr__bubble">{{ t.chat.joining }}</div>
        </div>
      </div>
      <div class="scr__composer">
        <span class="scr__composer-input">{{ t.chat.composer }}</span>
        <span class="scr__composer-send"><i class="fa fa-paper-plane"></i></span>
      </div>
    </template>

    <div v-if="navActive" class="scr__nav">
      <div v-for="item in navItems" :key="item.key" class="scr__nav-item"
        :class="{ 'scr__nav-item--active': item.key === navActive }">
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import copy from "@/locales/appScreen";

// Structure only; labels come from @/locales/appScreen, matched by key or position
const NAV_ITEMS = [
  { key: "home", icon: "fa fa-home" },
  { key: "budget", icon: "fa fa-pie-chart" },
  { key: "agenda", icon: "fa fa-calendar" },
  { key: "chat", icon: "fa fa-comments" },
  { key: "more", icon: "fa fa-th-large" },
];

const BUDGET_PCTS = [86, 100, 64];

const USAGE = [52, 74, 45, 63, 95, 80];

const WEEK = [
  { date: 12, active: true, dot: true },
  { date: 13, dot: true },
  { date: 14 },
  { date: 15, dot: true },
  { date: 16, dot: true },
  { date: 17, dot: true },
  { date: 18 },
];

const GROCERIES = [
  { done: true, by: "inah" },
  { done: true, by: "inah" },
  { done: false },
  { done: false, by: "budi" },
  { done: false },
  { done: false },
];

export default {
  name: "AppScreen",
  props: {
    screen: { type: String, required: true },
  },
  computed: {
    t() {
      return copy[this.$lang];
    },
    // Text arrays in the locale line up with these by position
    navItems() {
      return NAV_ITEMS.map((item) => ({ ...item, label: this.t.nav[item.key] }));
    },
    budgets() {
      return BUDGET_PCTS.map((pct, i) => ({ pct, ...this.t.budget.budgets[i] }));
    },
    usage() {
      return USAGE.map((value, i) => ({ value, label: this.t.bills.months[i] }));
    },
    week() {
      return WEEK.map((day, i) => ({ ...day, name: this.t.agenda.weekdays[i] }));
    },
    groceries() {
      return GROCERIES.map((item, i) => ({ ...item, ...this.t.shopping.items[i] }));
    },
    // Screens with their own action bar (bills, shopping, chat) hide the bottom nav
    navActive() {
      return { home: "home", budget: "budget", agenda: "agenda", maintenance: "more" }[this.screen] || null;
    },
  },
};
</script>

<style scoped lang="scss">
$ink: #23332a;
$muted: #74817a;
$line: #ece5d8;
$forest: #2f4a3a;
$apricot: #c26a35;
$grad: linear-gradient(135deg, #3d6b50, $forest);
$grad-warm: linear-gradient(135deg, #e9a274, #e0915f);

.scr {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  color: $ink;
  font-size: 11px;
}

// ----- Header -----
.scr__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 12px;
  background: #fff;
  border-bottom: 1px solid $line;
  flex-shrink: 0;
}

.scr__header-back {
  display: flex;
  align-items: center;
  gap: 10px;

  > i {
    font-size: 11px;
    color: $forest;
  }
}

.scr__eyebrow {
  font-size: 10px;
  color: $muted;
}

.scr__household {
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 800;
  color: $ink;

  i {
    font-size: 11px;
    color: $apricot;
  }
}

.scr__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.scr__icon-btn {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: #eef3ec;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: $forest;
  font-size: 12px;
}

.scr__badge-dot {
  position: absolute;
  top: 6px;
  right: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: $apricot;
  border: 1px solid #fff;
}

// ----- Body -----
.scr__body {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 12px 14px;
}

.scr__card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(35, 51, 42, 0.06);
  margin-bottom: 10px;
}

.scr__section-title {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 700;
  margin: 12px 2px 6px;

  span {
    font-weight: 500;
    color: $muted;
  }
}

.scr__list {
  padding: 2px 0;
}

.scr__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;

  & + & {
    border-top: 1px solid $line;
  }
}

.scr__row-main {
  flex: 1;
  min-width: 0;
}

.scr__row-title {
  font-weight: 600;
  font-size: 11.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &--done {
    color: $muted;
    text-decoration: line-through;
  }
}

.scr__row-sub {
  font-size: 10px;
  color: $muted;
  margin-top: 1px;
}

.scr__time {
  font-size: 10px;
  font-weight: 700;
  color: $forest;
  width: 32px;
}

.scr__chevron {
  color: #c4bcae;
  font-size: 13px;
}

.scr__amount {
  font-weight: 700;
  font-size: 11px;
}

.scr__chip {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 20px;
  background: rgba(224, 145, 95, 0.1);
  color: $apricot;
  font-size: 8.5px;
  font-weight: 700;
  vertical-align: middle;
}

// ----- Avatars & tiles -----
.scr__avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
  flex-shrink: 0;

  &--sm {
    width: 22px;
    height: 22px;
    font-size: 9px;
  }

  &--xs {
    width: 20px;
    height: 20px;
    font-size: 8.5px;
  }

  &--rina { background: $apricot; }
  &--budi { background: $forest; }
  &--kirana { background: #e08a3c; }
  &--inah { background: #2f9e7a; }
  &--vendor { background: #3a7bd5; }
  &--eyang { background: #8a6f5c; }
}

.scr__avatars {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 4px;

  &--stack {
    margin-top: 0;
    gap: 0;

    .scr__avatar {
      border: 2px solid #fff;
      margin-left: -6px;
    }
  }
}

.scr__tile {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;

  &--amber { background: #fff3dc; color: #d48806; }
  &--blue { background: #e6f0fd; color: #3a7bd5; }
  &--green { background: #e3f6ee; color: #2f9e7a; }
  &--red { background: #fde7ec; color: #d63a5a; }
  &--teal { background: #e0f5f6; color: #1f9aa3; }
}

.scr__text-green { color: #2f9e7a; }
.scr__text-red { color: #d63a5a; }
.scr__text-amber { color: #d48806; }

// ----- Progress -----
.scr__progress {
  height: 6px;
  border-radius: 6px;
  background: #ece6da;
  overflow: hidden;

  span {
    display: block;
    height: 100%;
    border-radius: 6px;
    background: $grad;

    &.is-warn { background: #f0a43a; }
    &.is-over { background: #d63a5a; }
  }

  &--light {
    background: rgba(255, 255, 255, 0.25);

    span { background: #fff; }
  }
}

// ----- Home -----
.scr__hero-card {
  background: $grad;
  border-radius: 16px;
  padding: 14px;
  color: #fff;
  box-shadow: 0 8px 20px rgba(224, 145, 95, 0.3);
}

.scr__hero-label {
  font-size: 10px;
  opacity: 0.8;
}

.scr__hero-amount {
  font-family: "Nunito", sans-serif;
  font-size: 20px;
  font-weight: 800;
  margin: 2px 0 10px;
}

.scr__hero-meta {
  display: flex;
  justify-content: space-between;
  font-size: 9.5px;
  opacity: 0.85;
  margin-top: 6px;
}

.scr__quick {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-top: 12px;
}

.scr__quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 9.5px;
  font-weight: 600;
}

.scr__quick-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $apricot;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(35, 51, 42, 0.08);
}

.scr__check {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 1.5px solid #c9c2b3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: #fff;
  flex-shrink: 0;

  &--done {
    background: #2f9e7a;
    border-color: #2f9e7a;
  }
}

.scr__alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
}

.scr__pill-btn {
  padding: 5px 12px;
  border-radius: 20px;
  background: $grad-warm;
  color: $ink;
  font-weight: 700;
  font-size: 10px;
}

// ----- Budget -----
.scr__segmented {
  display: flex;
  background: #e9e3d6;
  border-radius: 10px;
  padding: 3px;
  margin-bottom: 10px;
}

.scr__segmented-item {
  flex: 1;
  text-align: center;
  padding: 5px;
  border-radius: 8px;
  font-weight: 600;
  color: $muted;

  &--active {
    background: #fff;
    color: $forest;
    box-shadow: 0 1px 3px rgba(35, 51, 42, 0.1);
  }
}

.scr__split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.scr__stat {
  padding: 10px 12px;
  margin-bottom: 0;
}

.scr__stat-label {
  font-size: 9.5px;
  color: $muted;
}

.scr__stat-value {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 14px;
  margin-top: 2px;
}

.scr__budgets {
  padding: 10px 12px;
}

.scr__budget + .scr__budget {
  margin-top: 9px;
}

.scr__budget-head {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 4px;
}

.scr__budget-meta {
  font-size: 9px;
  color: $muted;
  margin-top: 3px;
}

// ----- Bills -----
.scr__bill-card {
  background: linear-gradient(135deg, #23332a, $forest);
  border-radius: 16px;
  padding: 14px;
  color: #fff;
  margin-bottom: 10px;
}

.scr__bill-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.scr__bill-logo {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #ffd23f;
  color: #23332a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}

.scr__bill-label {
  font-weight: 700;
  font-size: 12.5px;
}

.scr__bill-id {
  font-size: 9.5px;
  opacity: 0.7;
}

.scr__bill-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  font-weight: 700;
  font-size: 11px;

  span {
    display: block;
    font-weight: 400;
    font-size: 9px;
    opacity: 0.65;
  }
}

.scr__breakdown {
  padding: 8px 12px;

  > div {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    color: #56625a;
  }
}

.scr__breakdown-total {
  border-top: 1px dashed #ddd6c8;
  margin-top: 4px;
  padding-top: 8px !important;
  font-weight: 800;
  color: $ink !important;
  font-size: 12.5px;
}

.scr__methods {
  display: flex;
  gap: 6px;
}

.scr__method {
  flex: 1;
  text-align: center;
  padding: 7px 4px;
  border-radius: 10px;
  background: #fff;
  border: 1.5px solid $line;
  font-weight: 600;
  font-size: 10px;

  &--active {
    border-color: $apricot;
    color: $apricot;
    background: rgba(224, 145, 95, 0.05);
  }
}

.scr__bars {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 78px;
  padding: 10px 14px 6px;
}

.scr__bar {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 3px;

  span {
    width: 14px;
    border-radius: 4px;
    background: #dfe8dc;

    &.is-current {
      background: $grad;
    }
  }

  small {
    font-size: 8.5px;
    color: $muted;
  }
}

.scr__cta-bar {
  padding: 10px 14px 18px;
  background: #fff;
  border-top: 1px solid $line;
  flex-shrink: 0;
}

.scr__cta {
  display: block;
  text-align: center;
  padding: 11px;
  border-radius: 14px;
  background: $grad-warm;
  color: $ink;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 6px 16px rgba(224, 145, 95, 0.35);
}

// ----- Agenda -----
.scr__week {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.scr__day {
  position: relative;
  width: 32px;
  padding: 6px 0 9px;
  border-radius: 12px;
  text-align: center;

  small {
    display: block;
    font-size: 8.5px;
    color: $muted;
  }

  strong {
    font-size: 12.5px;
  }

  &--active {
    background: $grad;
    color: #fff;
    box-shadow: 0 6px 14px rgba(224, 145, 95, 0.35);

    small { color: rgba(255, 255, 255, 0.8); }
    .scr__day-dot { background: #fff; }
  }
}

.scr__day-dot {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: $apricot;
}

.scr__event {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
}

.scr__event-time {
  width: 34px;
  font-size: 9.5px;
  font-weight: 700;
  color: $muted;
  padding-top: 8px;
  flex-shrink: 0;
}

.scr__event-body {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  padding: 8px 10px;
  border-left: 3px solid $forest;
  box-shadow: 0 1px 3px rgba(35, 51, 42, 0.06);
}

.scr__event--green .scr__event-body { border-left-color: #2f9e7a; }
.scr__event--pink .scr__event-body { border-left-color: $apricot; }
.scr__event--amber .scr__event-body { border-left-color: #f0a43a; }

.scr__event--muted .scr__event-body {
  border-left-color: #c9c2b3;
  background: #eee8dc;
  box-shadow: none;
}

.scr__rsvp {
  display: flex;
  gap: 4px;
  margin-top: 6px;
}

.scr__rsvp-btn {
  padding: 3px 9px;
  border-radius: 20px;
  border: 1px solid #ddd6c8;
  font-size: 9.5px;
  font-weight: 600;
  color: #56625a;

  &--yes {
    background: #2f9e7a;
    border-color: #2f9e7a;
    color: #fff;
  }
}

.scr__rsvp-note {
  font-size: 9.5px;
  color: $muted;
  margin-left: 2px;
}

// ----- Shopping -----
.scr__live {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 10px;
  background: #e3f6ee;
  color: #1f7a5c;
  font-size: 10px;
  margin-bottom: 10px;
}

.scr__live-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2f9e7a;
  box-shadow: 0 0 0 3px rgba(47, 158, 122, 0.25);
  animation: scr-pulse 1.6s ease-in-out infinite;
}

@keyframes scr-pulse {
  50% { box-shadow: 0 0 0 6px rgba(47, 158, 122, 0); }
}

.scr__estimate {
  display: flex;
  justify-content: space-between;
  padding: 2px 4px;
  color: $muted;

  strong {
    color: $ink;
  }
}

// ----- Maintenance -----
.scr__health {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  margin-bottom: 10px;
}

.scr__health-item {
  background: #fff;
  border-radius: 12px;
  padding: 8px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(35, 51, 42, 0.06);

  strong {
    display: block;
    font-family: "Nunito", sans-serif;
    font-size: 17px;
    font-weight: 800;
  }

  span {
    font-size: 9px;
    color: $muted;
  }

  &--red strong { color: #d63a5a; }
  &--amber strong { color: #d48806; }
}

.scr__vendor {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
}

.scr__wa {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #25d366;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}

// ----- Chat -----
.scr__chat {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 8px;
  background: #f1ece1;
}

.scr__msg {
  display: flex;
  align-items: flex-end;
  gap: 6px;

  &--me {
    justify-content: flex-end;
  }
}

.scr__bubble {
  max-width: 75%;
  padding: 7px 10px;
  border-radius: 12px 12px 12px 4px;
  background: #fff;
  font-size: 11px;
  box-shadow: 0 1px 2px rgba(35, 51, 42, 0.06);

  &--me {
    border-radius: 12px 12px 4px 12px;
    background: $grad;
    color: #fff;
  }
}

.scr__chat-card {
  width: 72%;
  background: #fff;
  border-radius: 12px 12px 12px 4px;
  padding: 9px 10px;
  border: 1px solid #e4ddcd;
}

.scr__chat-card-head {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: $apricot;
  margin-bottom: 3px;
}

.scr__chat-card-amount {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 14px;
}

.scr__chat-card-status {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid $line;
  color: #2f9e7a;
  font-weight: 600;
  font-size: 10px;
}

.scr__composer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 18px;
  background: #fff;
  border-top: 1px solid $line;
  flex-shrink: 0;
}

.scr__composer-input {
  flex: 1;
  padding: 8px 12px;
  border-radius: 20px;
  background: #eef3ec;
  color: $muted;
}

.scr__composer-send {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: $grad;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

// ----- Bottom nav -----
.scr__nav {
  display: flex;
  justify-content: space-around;
  padding: 8px 6px 16px;
  background: #fff;
  border-top: 1px solid $line;
  flex-shrink: 0;
}

.scr__nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 8.5px;
  color: #a3ab9f;

  i {
    font-size: 14px;
  }

  &--active {
    color: $apricot;
    font-weight: 700;
  }
}
</style>
